<template>
  <v-menu bottom min-width="200px" rounded offset-y>
    <template v-slot:activator="{ on }">

      <v-btn icon x-large v-on="on" class="mr-6 hidden-sm-and-down">
        <v-avatar>
          <img
            v-if="user.image != null"
            :src="image"
            :alt="user.name"
            style="object-fit: cover"
          />

          <v-icon v-if="user.image == null"> mdi-account-circle </v-icon>
        </v-avatar>
      </v-btn>

      <v-btn icon x-large v-on="on" class="hidden-md-and-up" color="terciary">
        <v-avatar>
          <img
            v-if="user.image != null"
            :src="image"
            :alt="user.name"
            style="object-fit: cover"
          />

          <v-icon v-if="user.image == null"> mdi-account-circle </v-icon>
        </v-avatar>
      </v-btn>
    </template>

      <v-list-item-content style="background: #FFFFFF" class="justify-center align-center">
        <div class="mx-auto text-center">
          <v-avatar class="mt-2">
            <img
              :key="change"
              v-if="user.image != null"
              :src="image"
              :alt="user.name"
              style="object-fit: cover"
            />

            <v-icon v-if="user.image == null" size="55">
              mdi-account-circle
            </v-icon>
          </v-avatar>

          <h3 class="mt-3">{{ user.name }}</h3>
          <p class="caption mt-1">
            {{ user.email }}
          </p>

          <v-divider class="mx-2"></v-divider>

          <div class="d-flex flex-column">
            <v-btn rounded text @click="goToProfile"> Perfil </v-btn>
          </div>

          
          <v-divider class="mx-2"></v-divider>

        
          <div class="d-flex flex-column">
            <v-btn rounded text @click="logout"> <v-icon>mdi-logout</v-icon>Sair </v-btn>
          </div>

        </div>
      </v-list-item-content>

    
  </v-menu>
</template>

<script>
export default {
  data: () => ({
    change: false,
  }),
  
  


  methods: {
    logout() {
      localStorage.removeItem("token");
      localStorage.removeItem("expires");
      localStorage.removeItem("user");
      this.$router.push("/auth");
    },

    goToSettings() {
      if (this.$route.path != "/userconfig") {
        this.$router.push("/userconfig");
      }
    },

    goToProfile() {
      if (this.$route.path != "/userconfig") {
        this.$router.push("/userconfig");
      }
    },
  },

  computed: {
    user() {
      return JSON.parse(localStorage.getItem("user"));
    },

    image() {
      return this.user.image;
    },
  },

  watch: {
    user() {
      this.change = !this.change;
    },
  },
};
</script>
